import React from "react";
import { countHits, handleChangeIds } from "../../../../utils/checkBoxFunc";
import type { CheckboxSearchItem } from "../sp/portalSearchTypes";

type Props = {
  item: CheckboxSearchItem;
  // NOTE: サイドバーと詳細検索モーダルで同じリストを同時にmountするため、mountごとにidPrefixを変えてid衝突を防ぐ
  //       （重複idがあるとlabelが別mountのinputを操作し、モーダルのフォーカストラップがスクロールを先頭へ戻してしまう）
  idPrefix: string;
};

function PortalPCCheckboxList({ item, idPrefix }: Props) {
  const onChange = handleChangeIds(item.ids, item.setIds);

  return (
    <ul className="portalPcCheckList">
      {item.items.map((opt) => {
        const id = `${idPrefix}-${item.name}-${opt.value}`;
        return (
          <li key={opt.value}>
            <label htmlFor={id}>
              <input
                id={id}
                type="checkbox"
                value={opt.value}
                checked={item.ids.includes(opt.value)}
                onChange={onChange}
              />
              <span className="portalPcCheckLabel">
                {opt.label}({countHits(item.aggs.buckets, opt.value)}件)
              </span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}

export default PortalPCCheckboxList;
